export type RequestInterceptor = (
  url: string,
  init: RequestInit,
) => RequestInit | Promise<RequestInit>;

export type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';

export * from './types/ids';
export * from './types/person';
export * from './types/user';
export * from './types/user-v2';
export * from './types/trips';
export * from './types/address-search';
export * from './types/attribute-abbreviation';
export * from './types/passenger';
export * from './types/agreement-partner';
export * from './types/institution-cost-center-account';
export * from './types/notification';
export * from './types/absence-search';
export * from './types/travel-address';
